import React from "react"
import { Title, OnboardingScreenContainer, Text } from "dash-styled"
import { AuthForm } from "../../../../../../Common/AuthForm/AuthForm"
import { AuthFormView } from "../../../../../../../Models/Client/AuthFormView"
import { ConsentStatement } from "../../../../../../Common/AuthForm/ConsentStatement/ConsentStatement"
import { AlreadyUser } from "./AlreadyUser"
import { CustomerReview } from "./CustomerReview"
import { useAppState } from "../../../../../../../Hooks/useReduxState"
import { UserType } from "../../../../../../../Models/Client/User"

interface SetUserStageProps {
    onForward: () => void
    loginRoute: string
    login?: boolean
}

export const SetUserStage = ({
    onForward,
    loginRoute,
    login
}: SetUserStageProps) => {
    const confirmUser = useAppState(state => state.auth.user)
    const shouldConfirmUser = confirmUser.type === UserType.unconfirmed

    return (
        <OnboardingScreenContainer celebrate={false} forward={false}>
            <div id="maincontent" className="flex flex-1 w-full">
                <div className="flex justify-center" style={{ flex: 3 }}>
                    <div
                        className="flex flex-col items-center justify-center"
                        style={{ width: "460px" }}
                    >
                        <Title
                            color="darkviolet"
                            variant="heading1"
                            className="text-center"
                            weight="semibold"
                        >
                            {shouldConfirmUser
                                ? "Enter Verification code"
                                : "Let's get started"}
                        </Title>
                        <Text
                            component="span"
                            color="gray"
                            className="text-center mb-10 px-16 mx-4"
                        >
                            {shouldConfirmUser
                                ? "The verification code is sent to your email"
                                : login
                                ? "Start processing your unstructured data"
                                : "Start processing your unstructured data today with our 7-day trial. No card required"}
                        </Text>
                        <AuthForm
                            view={
                                shouldConfirmUser
                                    ? AuthFormView.signup_confirm
                                    : login
                                    ? AuthFormView.login
                                    : AuthFormView.signup
                            }
                            squashSuccessMessage={true}
                            onLoginSuccess={onForward}
                            prefilledEmail={
                                confirmUser.type === UserType.unconfirmed
                                    ? confirmUser.email
                                    : undefined
                            }
                        />
                        {!login && (
                            <div>
                                <AlreadyUser
                                    className="mt-4 -mb-4"
                                    loginRoute={loginRoute}
                                />
                                <ConsentStatement />
                            </div>
                        )}
                    </div>
                </div>
                <CustomerReview />
            </div>
        </OnboardingScreenContainer>
    )
}
